export default __webpack_public_path__ + "static/src/companys/fubon/assets/images/logo/logo_dark.svg";